
  <div *ngIf="from =='bid'" class="modal-center">
     <div class="modal-header bg-light modal-dialog-centered">
      <div class="height-auto">
       <h4 class="modal-title" >
        {{ 'home.quote.Cancelbid' | cxTranslate }}
       </h4>
       <h6 class="modal-title small text-dark text-center">{{ 'home.quote.Thiscancel' | cxTranslate }}</h6>
     </div>
     <div class="modal-footer bg-light">
       <div class="form-group">
         <button class="btn btn-block btn-danger btn-lg" type="submit" data-dismiss="modal" (click)="editQuote(data)" [disabled]="disabledBtn">
           {{ 'home.quote.Icancel' | cxTranslate }}
         </button>
         <button class="btn btn-block btn-secondary btn-lg" type="submit" data-dismiss="modal" (click)="close()">
           {{ 'home.quote.Close' | cxTranslate }}
         </button>
       </div>
     </div>
    </div>
  </div>
 <div  *ngIf="from =='order'"  class="modal-center">
     <div class="modal-header bg-light modal-dialog-centered">
      <div class="height-auto">
       <h4 class="modal-title" >
        Cancel Order
       </h4>
       <h6 class="modal-title small text-dark text-center">Are you sure you want to cancel the order?</h6>
     </div>
     <div class="modal-footer bg-light">
       <div class="form-group">
         <button class="btn btn-block btn-danger btn-lg" type="submit" data-dismiss="modal" (click)="editQuote(data)" [disabled]="disabledBtn">
           I want to cancel my order
         </button>
         <button class="btn btn-block btn-secondary btn-lg" type="submit" data-dismiss="modal" (click)="close()">
           Close
         </button>
       </div>
     </div>
    </div>
  </div>

